import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import jp from './jp.json';

const configuredI18n = initReactI18next
  ? i18n.use(initReactI18next)
  : i18n;

configuredI18n.init({
  resources: {
    en: { translation: en },
    ja: { translation: jp },
  },
  lng: localStorage.getItem('ci_lang') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
